import { useState, useEffect, useCallback } from "react";

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const debouncedSetValue = useCallback(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  useEffect(() => {
    const cleanup = debouncedSetValue();
    return cleanup;
  }, [debouncedSetValue]);

  return debouncedValue;
}

export default useDebounce;
